// Backward-compat shim. ImageUpload was the original name; AssetUpload is the
// generalised version that supports PDF previews and an `accept` prop.
import AssetUpload from "@/components/AssetUpload";

export default function ImageUpload(props) {
  return <AssetUpload {...props} />;
}
